/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import dreexcecoes_api from "../../../api/dreexcecoes_api";
import { fileToBase64, getExtension } from 'utils/Base64Helper';
import download from "downloadjs";
import SweetAlert from "react-bootstrap-sweetalert";
import Presentational from './presentational';
import { getSessionCookie } from 'utils/cookies';
import { formateDateByMesAno, formateMesAno } from "utils/formats";

export default function ImportExcecoesDREcsv({ grupoEconomicoSelected }) {

  const [file, set_file] = React.useState(null);
  const [isLoadingCsv, setisLoadingCsv] = useState(false);
  const [dataResult, setDataResult] = useState([]);
  const session = getSessionCookie();

  const [alert, setalert] = React.useState();
  const showAlert = (message, tipo) => {
    setalert(<SweetAlert
      error={tipo === 'error' ? true : false}
      warning={tipo === 'warning' ? true : false}
      success={tipo === 'success' ? true : false}
      title="Aviso"
      onConfirm={() => setalert(null)}
    >
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </SweetAlert>);
  };

  async function DownloadCsv() {
    setisLoadingCsv(true);
    const apiResponse = await dreexcecoes_api.getCsvTemplateImport("modeloDREExcecoes");

    if (apiResponse.status == 200)
      download(new Blob([apiResponse.data]), "modeloDREExcecoes.csv", "application/csv");
    else
      showAlert(apiResponse.error, "error");

    setisLoadingCsv(false);
  }

  const onChangeFileHandler = async (event) => {
    let arquivo = event.target.files[0];

    let extention = getExtension(arquivo != null ? arquivo.name : null);

    if (extention !== "csv") {
      set_file(null);
      showAlert("Informe um arquivo do formato csv!", "error");
      return;
    }

    if (event.target.files.length > 0) {
      set_file(event.target.files[0]);
    }
  };

  function importDataCSV() {

    if (file == null) {
      showAlert("Escolha um arquivo csv para ser importado!", "error");
      return;
    }

    setisLoadingCsv(true);
    var formData = new FormData();
    formData.append("file", file);

    dreexcecoes_api.postImportCsv(session.usuario_Id, formData).then(result => {
      if (result.status == 200) {
        showAlert("Upload Concluído!", "success")
        setDataResult(result.data)
      }
      else {
        showAlert(result.message, "error")
        setDataResult([])
      }
      setisLoadingCsv(false);
    })
  }

  function onClickDownloadCsv() {
    DownloadCsv();
  }

  return React.createElement(Presentational, {
    onChangeFileHandler,
    onClickDownloadCsv,
    isLoadingCsv,
    dataResult,
    alert,
    importDataCSV,
  });
}